<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.quote.save_to_a_collection' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">


    <div class="collections-container">
        <div>
            <div *ngFor="let collection of collections">
                <div>
                    <div *ngIf="collection.count || collection.count === 0" class="collection-badge">
                        {{collection.count}}</div>
                    <div>{{collection.collectionName}}</div>
                    <div class="completion-icon" *ngIf="isSKUInCollection(sku, collection)" >
                    <daz-icon                         
                        [name]="'check'" 
                        [size]="'20px'" 
                        [color]="'#318836'">
                    </daz-icon>
                    </div>
                </div>
                <div><hub-button [size]="'md'" [icon]="'chevron-right'" (buttonClick)="collectionSelected(collection)"
                        [disabled]="isSKUInCollection(sku, collection)"
                        [style]="'outline'"></hub-button>
                </div>
            </div>
        </div>
    </div>

</div>
<div class="modal-footer-container">
    <div class="overflow-footer" (click)="manageCollectionsEvent()">
        <span><daz-icon [name]="'gear'" [size]="'20px'" [color]="'#5D5D5D'"></daz-icon></span>{{
        'bikeshop.workshop.jobcard.quote.manage_collections' | translate}}
    </div>
</div>
<!-- <p-confirmDialog key="delete-collection-dialog"></p-confirmDialog> -->